export default {
    routerName: '参数詳細',
    config: {
        id: 'ID',
        typeName: 'タイプ',
        typeImage: '画像',
        typeContent: '内容',
        name: 'パラメタ名',
        key1: 'パラメタキー1',
        value1: 'パラメタ値1',
        key2: 'パラメタキー2',
        value2: 'パラメタ値3',
        key3: 'パラメタキー3',
        value3: 'パラメタ値3',
        key4: 'パラメタキー4',
        value4: 'パラメタ値4',
        key5: 'パラメタキー5',
        value5: 'パラメタ値5',
        key6: 'パラメタキー6',
        value6: 'パラメタ値6',
        key7: 'パラメタキー7',
        value7: 'パラメタ値7',
        key8: 'パラメタキー8',
        value8: 'パラメタ値8',
        key9: 'パラメタキー9',
        value9: 'パラメタ値9',
        key10: 'パラメタキー10',
        value10: 'パラメタ値10',
    },
};
